<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    :subtitle="connectedService.name"
    @on-confirm="sync"
    @on-cancel="hide()"
    :okText="$t('Sync')"
    :closeText="$t('Close')"
  >
    <v-overlay
        :value="loading"
        absolute
    >
        <v-progress-circular
            class="my-4"
            :size="50"
            width="5"
            color="primary"
            indeterminate
        ></v-progress-circular>
    </v-overlay>
    <v-card flat class="my-0">
      <v-card-text>
        <WinbizControls v-if="connectedService.serviceName === 'Winbiz'" :winbizService="connectedService" @loading="loading = $event"></WinbizControls>
        <div v-for="(param, index) in connectedService.syncParams" :key="index">
          <v-switch
            v-if="isBoolParam(param.value)"
            v-model="param.value"
            :label="paramLabel(param.name)"
            color="primary"
          ></v-switch>
          <v-text-field
            v-else-if="connectedService.serviceName !== 'Winbiz'"
            :label="paramLabel(param.name)"
            v-model="param.value"
          ></v-text-field>
        </div>
      </v-card-text>
    </v-card>
  </base-modal>
</template>
<script>
import ConnectedServiceService from '@/services/ConnectedServiceService';
import ConnectedService from '@/ecm/models/connectedService/ConnectedService';
import startCase from 'lodash/startCase';
import Utils from '@/ecm/common/Utils';
import WinbizControls from './Winbiz/WinbizControls.vue';

export default {
    name: 'ConnectedServiceSyncModal',
    components: { WinbizControls },
    created() {
        ConnectedServiceService.getList().then((data) => {
            this.serviceList = data;
        });
    },
    data() {
        return {
            serviceList: [],
            modal: {
                title: this.$t('Sync'),
                key: 'connectedServiceSyncModal',
            },
            open: false,
            connectedService: new ConnectedService(),
            loading: false
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modal.key];
        },
        modalTitle() {
            return (
                this.modal.title +
                (this.connectedService.description
                    ? ' - ' + this.connectedService.description
                    : '')
            );
        },
    },
    methods: {
        sync() {
            this.modalInstance.progress(true);
            if (this.connectedService.serviceName === 'Wyzio') {
                const syncParamsObj = this.connectedService.syncParams.reduce((acc, item) => {
                    acc[item.name] = item.value;
                    return acc;
                }, {});
                ConnectedServiceService.syncWyzio(this.connectedService.id, syncParamsObj)
                    .then((result) => {
                        if (result && result.length > 0) {
                            var errorMessage = `${this.$t(
                                'SyncFinishedWithErrors'
                            )}:\n ${result.join('\n - ')}`;
                            Utils.toast.warning(errorMessage);
                        } else {
                            Utils.toast.success(this.$t('SyncFinishedSuccessfully'));
                        }
                        this.hide();
                        this.$emit('on-sync');
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.modalInstance.progress(false);
                    });
            } else {
                ConnectedServiceService.sync(this.connectedService.toDto())
                    .then((result) => {
                        if (result && result.length > 0) {
                            var errorMessage = `${this.$t(
                                'SyncFinishedWithErrors'
                            )}:\n ${result.join('\n - ')}`;
                            Utils.toast.warning(errorMessage);
                        } else {
                            Utils.toast.success(this.$t('SyncFinishedSuccessfully'));
                        }
                        this.hide();
                        this.$emit('on-sync');
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.modalInstance.progress(false);
                    });
            }
        },
        isBoolParam(paramValue) {
            return paramValue === false || paramValue === true;
        },
        paramLabel(paramName) {
            return startCase(paramName).replace('Sync', this.$t('Sync'));
        },
        edit(connectedServiceId) {
            ConnectedServiceService.getById(connectedServiceId).then((dto) => {
                dto.SyncParams = this.serviceList.find(
                    (x) => x.ServiceName == dto.ServiceName
                ).SyncParams;
                this.connectedService = new ConnectedService(dto);
                this.show();
            });
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
